import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGeneral = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "general",
	xmlns: "http://www.w3.org/2000/svg",
	width: 51.612,
	height: 44.624,
	viewBox: "0 0 51.612 44.624",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_68791",
			"data-name": "Path 68791",
			d: "M354.282,254.9v-2.063c0-7.281.018-14.563-.02-21.844a2.568,2.568,0,0,1,1.25-2.484,5.122,5.122,0,0,0-.129-8.742,2.166,2.166,0,0,1-1.12-2.17c.056-2.437.018-4.876.018-7.244h-3.6c0,2.468-.05,4.808.023,7.144a2.3,2.3,0,0,1-1.173,2.328,5.1,5.1,0,0,0-.141,8.63,2.667,2.667,0,0,1,1.309,2.623c-.036,7.281-.018,14.563-.018,21.844V254.9Zm37.255-44.624v2.143c0,4.58.03,9.16-.036,13.74a2.449,2.449,0,0,1-.8,1.737c-3.717,2.683-3.726,6.63-.02,9.384a2.469,2.469,0,0,1,.824,1.728c.067,4.639.037,9.28.037,13.92v1.936h3.6V253c0-4.58.03-9.16-.022-13.74a2.435,2.435,0,0,1,1.2-2.338c3.26-2.283,3.132-6.483-.065-8.833a2.867,2.867,0,0,1-1.062-1.957c-.091-4.638-.048-9.28-.048-13.92v-1.937Zm-13.418.029c-.471,2.493-.471,2.493-2.433,4.64a5.27,5.27,0,0,0,1.018,7.89,2.417,2.417,0,0,1,1.191,2.349c-.033,9.159-.019,18.318-.019,27.478v2.208h3.581v-2.034c0-9.159.013-18.319-.017-27.478a2.6,2.6,0,0,1,1.2-2.52c3.349-2.3,3.209-6.569-.109-8.908a3.672,3.672,0,0,1-1.045-1.807,7.13,7.13,0,0,1-.123-1.818Zm-10.175,44.584c0-2.538.038-4.93-.017-7.319a2.459,2.459,0,0,1,1.224-2.472c2.878-1.887,3.2-6.208.468-8.166-1.551-1.113-1.727-2.3-1.7-3.916.069-3.589.022-7.179.022-10.81h-3.582c0,4.1.04,8.118-.042,12.131a2.621,2.621,0,0,1-.916,1.848c-3.561,2.507-3.568,6.771-.011,9.293a2.643,2.643,0,0,1,.926,1.821c.1,2.5.043,5.009.043,7.59Zm-.137-40.056v-4.472h-3.294v4.472Z",
			transform: "translate(-347.086 -210.277)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_68792",
			"data-name": "Path 68792",
			d: "M354.282,255.035h-3.6v-1.979c0-7.282-.018-14.563.018-21.844a2.667,2.667,0,0,0-1.309-2.623,5.1,5.1,0,0,1,.141-8.63,2.3,2.3,0,0,0,1.173-2.328c-.073-2.336-.023-4.676-.023-7.144h3.6c0,2.368.038,4.808-.018,7.244a2.166,2.166,0,0,0,1.12,2.17,5.122,5.122,0,0,1,.129,8.742,2.568,2.568,0,0,0-1.25,2.484c.038,7.281.02,14.563.02,21.844Z",
			transform: "translate(-347.086 -210.412)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_68793",
			"data-name": "Path 68793",
			d: "M463.6,210.277h3.6v1.938c0,4.64-.043,9.282.048,13.92a2.867,2.867,0,0,0,1.062,1.957c3.2,2.35,3.325,6.55.065,8.833a2.435,2.435,0,0,0-1.2,2.338c.052,4.579.022,9.16.022,13.74v1.864h-3.6v-1.936c0-4.64.03-9.281-.037-13.92a2.468,2.468,0,0,0-.824-1.728c-3.706-2.754-3.7-6.7.02-9.384a2.449,2.449,0,0,0,.8-1.737c.066-4.579.036-9.159.036-13.74Z",
			transform: "translate(-419.146 -210.277)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_68794",
			"data-name": "Path 68794",
			d: "M426.256,210.358H429.5a7.133,7.133,0,0,0,.123,1.818,3.672,3.672,0,0,0,1.045,1.807c3.318,2.338,3.458,6.609.109,8.908a2.6,2.6,0,0,0-1.2,2.52c.031,9.159.017,18.319.017,27.478v2.034h-3.581v-2.208c0-9.159-.014-18.319.019-27.478a2.417,2.417,0,0,0-1.191-2.349,5.27,5.27,0,0,1-1.018-7.89C425.785,212.851,425.785,212.851,426.256,210.358Z",
			transform: "translate(-395.223 -210.329)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_68795",
			"data-name": "Path 68795",
			d: "M392.032,275.954H388.45c0-2.581.062-5.089-.043-7.59a2.643,2.643,0,0,0-.926-1.821c-3.557-2.522-3.55-6.785.011-9.293a2.621,2.621,0,0,0,.916-1.848c.082-4.012.042-8.027.042-12.131h3.582c0,3.631.048,7.221-.022,10.81-.031,1.613.145,2.8,1.7,3.916,2.73,1.959,2.41,6.28-.468,8.167a2.459,2.459,0,0,0-1.224,2.471C392.07,271.024,392.032,273.416,392.032,275.954Z",
			transform: "translate(-371.174 -231.34)",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_68796",
			"data-name": "Path 68796",
			d: "M398.574,214.985H395.28v-4.472h3.294Z",
			transform: "translate(-377.853 -210.428)",
			fill: "#fff"
		})
	]
});
export default SvgGeneral;
